import { render, staticRenderFns } from "./product-display.vue?vue&type=template&id=41dffa3a&"
import script from "./product-display.vue?vue&type=script&lang=js&"
export * from "./product-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports